import React, {Dispatch, SetStateAction} from "react";
import Button from "@awsui/components-react/button";
import {useMutation} from "react-query";
import {FlashbarProps} from "@awsui/components-react/flashbar/interfaces";
import addRiderSynonyms from "api/addRiderSynonyms";
import Box from "@awsui/components-react/box";
import {useAuth} from "hooks/useAuth";
import RiderSynonym from "model/RiderSynonym";


interface AddRiderSynonymsButtonProps {
    synonyms: Map<string, RiderSynonym> | undefined;
    setSubmitMessage: Dispatch<SetStateAction<FlashbarProps.MessageDefinition | undefined>>;
}

const AddRiderSynonymsButton: React.FC<AddRiderSynonymsButtonProps> = (props) => {

    const synonyms = props.synonyms;

    const [{user}] = useAuth();

    const {
        mutate: addRiderSynonymsMutation,
        isLoading: addRiderSynonymsIsLoading
    } = useMutation((synonyms: RiderSynonym[]) => addRiderSynonyms(synonyms, user?.token), {
            onSuccess: () => {
                props.setSubmitMessage({
                    header: "Rider synonyms added correctly",
                    type: "success",
                    content: "",
                })
            },
            onError: () => {
                props.setSubmitMessage({
                    header: "Error when adding rider synonyms",
                    type: "error",
                    content: "Try to refresh the page.",
                })
            }
        }
    );

    const submitRiderSynonyms = () => {
        const selectedSynonyms: RiderSynonym[] = [];
        synonyms?.forEach((value, key) => {
            selectedSynonyms.push(new RiderSynonym(value.preferredNameId, key));
        });
        addRiderSynonymsMutation(selectedSynonyms);
    }

    return (
        <Box float="right">
            <Button
                disabled={!synonyms}
                iconAlign="left"
                loading={addRiderSynonymsIsLoading}
                variant="primary"
                onClick={submitRiderSynonyms}
            >
                Submit
            </Button>
        </Box>
    );
};

export default AddRiderSynonymsButton;
